const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['doctor'] = require('../middleware/doctor.js')
middleware['doctor'] = middleware['doctor'].default || middleware['doctor']

middleware['loginRedirect'] = require('../middleware/loginRedirect.js')
middleware['loginRedirect'] = middleware['loginRedirect'].default || middleware['loginRedirect']

middleware['redirectToNetwork'] = require('../middleware/redirectToNetwork.js')
middleware['redirectToNetwork'] = middleware['redirectToNetwork'].default || middleware['redirectToNetwork']

middleware['routeRedirects'] = require('../middleware/routeRedirects.js')
middleware['routeRedirects'] = middleware['routeRedirects'].default || middleware['routeRedirects']

export default middleware
